import type { ResponsiveValues } from '../config/responsiveness';
import { BREAKPOINTS } from '../config/responsiveness';
import { useViewportSize } from './useViewportSize';

const breakpoints = Object.keys(BREAKPOINTS) as (keyof typeof BREAKPOINTS)[];

export function useResponsiveValue<const ResponsiveValueType extends NonNullable<unknown>>(
  value: ResponsiveValues<ResponsiveValueType> | ResponsiveValueType,
): ResponsiveValueType {
  const { matchingBreakpoint } = useViewportSize();
  const currentBreakpoint = breakpoints[matchingBreakpoint];
  const notObjectOrNotResponsiveObjectValue =
    typeof value !== 'object' || (typeof value === 'object' && !('sm' in value));

  if (notObjectOrNotResponsiveObjectValue) {
    return value;
  }

  const breakpointValue = value[currentBreakpoint];

  if (breakpointValue != null) {
    return breakpointValue;
  }

  // Find the closest smaller breakpoint above sm with a value
  for (const breakpoint of breakpoints.slice(1, matchingBreakpoint).reverse()) {
    const valueAtBreakpoint = value[breakpoint];
    if (valueAtBreakpoint != null) return valueAtBreakpoint;
  }

  return value.sm;
}
